module.exports = __webpack_public_path__ + "sounds/a5dff265d01eb1f8e3626e7be84fe6a3.mp3";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/sounds/prologue.mp3
// module id = 85
// module chunks = 0